// 这个文件是自动生成的通过 plop
import * as g from './g.js';

export const dataMap = {
  十堰市: g['十堰市'],
  咸宁市: g['咸宁市'],
  孝感市: g['孝感市'],
  宜昌市: g['宜昌市'],
  恩施土家族苗族自治州: g['恩施土家族苗族自治州'],
  武汉市: g['武汉市'],
  神农架: g['神农架'],
  荆州市: g['荆州市'],
  荆门市: g['荆门市'],
  襄阳市: g['襄阳市'],
  鄂州市: g['鄂州市'],
  随州市: g['随州市'],
  黄冈市: g['黄冈市'],
  黄石市: g['黄石市'],
  中国: g['中国'],
  丹江口市: g['丹江口市'],
  张湾区: g['张湾区'],
  房县: g['房县'],
  竹山县: g['竹山县'],
  竹溪县: g['竹溪县'],
  茅箭区: g['茅箭区'],
  郧西县: g['郧西县'],
  郧阳区: g['郧阳区'],
  咸安区: g['咸安区'],
  嘉鱼县: g['嘉鱼县'],
  崇阳县: g['崇阳县'],
  赤壁市: g['赤壁市'],
  通城县: g['通城县'],
  通山县: g['通山县'],
  云梦县: g['云梦县'],
  大悟县: g['大悟县'],
  孝南区: g['孝南区'],
  孝昌县: g['孝昌县'],
  安陆市: g['安陆市'],
  应城市: g['应城市'],
  汉川市: g['汉川市'],
  五峰土家族自治县: g['五峰土家族自治县'],
  伍家岗区: g['伍家岗区'],
  兴山县: g['兴山县'],
  夷陵区: g['夷陵区'],
  安远县: g['安远县'],
  宜都市: g['宜都市'],
  枝江市: g['枝江市'],
  猇亭区: g['猇亭区'],
  秭归县: g['秭归县'],
  西陵区: g['西陵区'],
  长阳县: g['长阳县'],
  利川市: g['利川市'],
  咸丰县: g['咸丰县'],
  宣恩县: g['宣恩县'],
  巴东县: g['巴东县'],
  建始县: g['建始县'],
  恩施市: g['恩施市'],
  来凤县: g['来凤县'],
  鹤峰县: g['鹤峰县'],
  东西湖区: g['东西湖区'],
  新洲区: g['新洲区'],
  武昌区: g['武昌区'],
  汉南区: g['汉南区'],
  汉阳区: g['汉阳区'],
  江夏区: g['江夏区'],
  江岸区: g['江岸区'],
  江汉区: g['江汉区'],
  洪山区: g['洪山区'],
  硚口区: g['硚口区'],
  蔡甸区: g['蔡甸区'],
  青山区: g['青山区'],
  黄陂区: g['黄陂区'],
  公安县: g['公安县'],
  松滋市: g['松滋市'],
  江陵县: g['江陵县'],
  沙市区: g['沙市区'],
  洪湖市: g['洪湖市'],
  监利市: g['监利市'],
  石首市: g['石首市'],
  荆州区: g['荆州区'],
  东宝区: g['东宝区'],
  京山市: g['京山市'],
  掇刀区: g['掇刀区'],
  沙洋县: g['沙洋县'],
  钟祥市: g['钟祥市'],
  保康县: g['保康县'],
  南漳县: g['南漳县'],
  宜城市: g['宜城市'],
  樊城区: g['樊城区'],
  老河口市: g['老河口市'],
  襄城区: g['襄城区'],
  襄州区: g['襄州区'],
  谷城县: g['谷城县'],
  华容区: g['华容区'],
  梁子湖区: g['梁子湖区'],
  鄂城区: g['鄂城区'],
  广水市: g['广水市'],
  曾都区: g['曾都区'],
  随县: g['随县'],
  团风县: g['团风县'],
  武穴市: g['武穴市'],
  浠水县: g['浠水县'],
  红安县: g['红安县'],
  罗田县: g['罗田县'],
  英山县: g['英山县'],
  蕲春县: g['蕲春县'],
  麻城市: g['麻城市'],
  黄梅县: g['黄梅县'],
  大冶市: g['大冶市'],
  阳新县: g['阳新县'],
  湖北省: g['湖北省'],
}